import actions from './actions';
import authActions from '../auth/actions'

const initState = {
  fetchedStatusData: null,
  fetchingStatusData: false,
  fetchingStatusError: false
};

export default function widgetReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCHED_STATUS:
      return {
        ...state,
        fetchingStatusData: false,
        fetchingStatusError: false,
        fetchedStatusData: action.payload,
      };
    case actions.RESET_FETCHED_STATUS:
      return {
        ...state,
        fetchingStatusData: false,
        fetchingStatusError: false,
        fetchedStatusData: null,
      };
    case actions.FETCHING_STATUS:
      return {
        ...state,
        fetchingStatusData: true,
        fetchingStatusError: false,
      };
    case actions.FETCH_STATUS_ERROR:
      return {
        ...state,
        fetchingStatusData: false,
        fetchingStatusError: true,
        fetchedStatusData: null,
      };
    case authActions.LOGOUT:
      return {
        ...initState,
      };
    
    default:
      return state;
  }
}
